'use client'

import { Text } from '@macarongfactory/web-ui'

import { MycleAppLogo } from '@/shared/assets/icons'

import { LOCK_AB_AF_SUB2 } from '../../_features/modoocar-lock-ab'
import {
  MODOOCAR_CODE,
  MODOOCAR_PROMOTION_BANNER_ONELINK_URL,
  useModoocarAppLink,
  useModoocarImpression,
  useModoocarTracking,
} from '../_features/modoocar'

const APP_LOGO_SIZE_PX = 32
const BANNER_BACKGROUND = 'linear-gradient(0deg, #0D3E51 0%, #2D3741 100%)'

const AppPromoBanner = () => {
  // [정책]: 배너는 딥링크 없이 1만원 쿠폰 메시지로 통일해서 webshow 딥링크를 싣지 않습니다.
  const openAppLink = useModoocarAppLink({
    fallbackUrl: MODOOCAR_PROMOTION_BANNER_ONELINK_URL,
    afSub2: LOCK_AB_AF_SUB2.PROMOTION_BANNER,
    withDeepLink: false,
  })
  const { sectionShow, itemClick } = useModoocarTracking()
  const sectionRef = useModoocarImpression<HTMLElement>(() =>
    sectionShow(MODOOCAR_CODE.PROMOTION_BANNER, '프로모션 배너')
  )

  // [앱]: 모바일은 location.href로 이동해야 iOS 웹뷰에서 앱스토어를 다녀온 뒤 빈 화면이 뜨지 않습니다.
  const handleClick = () =>
    openAppLink(() =>
      itemClick(MODOOCAR_CODE.PROMOTION_BANNER, 'button', '프로모션 배너 버튼')
    )

  return (
    <section
      ref={sectionRef}
      aria-label='마이클 앱 다운로드 배너'
      className='flex items-center gap-dimension-x4 px-dimension-x6 py-dimension-x4'
      style={{ background: BANNER_BACKGROUND }}
    >
      <MycleAppLogo
        width={`${APP_LOGO_SIZE_PX}`}
        height={`${APP_LOGO_SIZE_PX}`}
      />

      <div className='flex flex-1 flex-col'>
        <Text variant='title-2-medium' color='text-foreground-static-white'>
          지금 마이클 앱 다운받고
        </Text>
        <Text variant='title-1-semibold' color='text-foreground-static-white'>
          1만원 쿠폰 받아보세요
        </Text>
      </div>

      <button
        type='button'
        aria-label='마이클 앱 다운받기'
        onClick={handleClick}
        className='flex h-dimension-x8 shrink-0 items-center rounded-dimension-x2 bg-background-static-white px-dimension-x3'
      >
        <Text variant='body-2-semibold' color='text-foreground-neutral-normal'>
          다운받기
        </Text>
      </button>
    </section>
  )
}

export default AppPromoBanner
